const __WEBPACK_NAMESPACE_OBJECT__ = KalturaPlayer.ui.preacti18n;